export default "__VITE_ASSET__C2BulJPV__"